export enum ModalCopy_Type {
    PROJECT     = 'project',
    GOAL        = 'goal',
    TASK        = 'task',
    TASKS       = 'tasks'
}

export enum ModalCopy_CurrentStep {
    COPY_PROJECT        = 'copy-project',
    COPY_GOAL           = 'copy-goal',
    COPY_TASK           = 'copy-task',
    COPY_TASKS           = 'copy-tasks',
    LOADING             = 'loading',
    CHECKING_USERS      = 'checking-users',
    ADD_MISSING_USERS   = 'add-missing-users',
    COPYING             = 'copying',
}